function handleValidation(form: HTMLFormElement) {
  const clearoutFeedbackContainer = form.querySelector('.cofeedback') as HTMLElement;
  const clearoutFeedbackMessage = form.querySelector('.feedback_msg');
  const clearoutError =
    clearoutFeedbackMessage &&
    clearoutFeedbackMessage.textContent &&
    clearoutFeedbackMessage.textContent.trim() !== ''
      ? clearoutFeedbackMessage.textContent.trim()
      : null;

  const hubspotErrors = Array.from(form.querySelectorAll('.hs-error-msg'));
  const hubspotErrorTexts = hubspotErrors.map((e) => e.textContent?.trim()).filter(Boolean);

  // console.log('Clearout error:', clearoutError);
  // console.log('HubSpot error(s):', hubspotErrorTexts);

  if (hubspotErrorTexts.length > 0) {
    form.classList.add('has-hubspot-message');
    // console.log('Hiding Clearout feedback');
    // console.log('Clearout feedback container:', clearoutFeedbackContainer);
    if (clearoutFeedbackContainer) {
      clearoutFeedbackContainer.style.display = 'none';
    }
  } else if (clearoutError == null) {
    if (clearoutFeedbackContainer) {
      clearoutFeedbackContainer.style.setProperty('display', 'none', 'important');
    }
  } else {
    form.classList.remove('has-hubspot-message');
    if (clearoutFeedbackContainer) {
      clearoutFeedbackContainer.style.display = 'block';
    }
  }
}

const APP_TOKEN =
  '418a262f54dc4bc57ff208c10bbe1dee:f08b80bcd3116220aca9e5efb71443355d8a5260ac7769138feb8c831df80a79';

// Helper to load the Clearout script and resolve when loaded
function loadClearoutScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (window.clearout && window.clearout.emailValidator) {
      resolve();
      return;
    }
    const existing = document.querySelector('script[src*="clearout_js_widget.js"]');
    if (existing) {
      existing.addEventListener('load', () => resolve());
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://clearout.io/wp-content/co-js-widget/clearout_js_widget.js';
    script.async = true;
    script.onload = () => resolve();
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

// Helper to poll for Clearout API readiness
function pollForClearoutApi(retries = 20): Promise<void> {
  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      if (
        window.clearout &&
        window.clearout.emailValidator &&
        typeof window.clearout.$ === 'function'
      ) {
        clearInterval(interval);
        resolve();
      } else {
        retries -= 1;
        if (retries <= 0) {
          clearInterval(interval);
          reject(new Error('Clearout API did not initialize in time.'));
        }
      }
    }, 100);
  });
}

// Initialize Clearout
const clearout = (window.clearout = window.clearout || []);
const opts: ClearoutOptions = {
  app_token: APP_TOKEN,
  auto_validation: false,
  debug: false,
};
clearout.push(['initialize', opts]);
loadClearoutScript();

async function attachClearoutEmailValidator(form: HTMLFormElement) {
  const emailInput = form.querySelector('input[type="email"]');
  if (!(emailInput instanceof HTMLInputElement)) {
    console.error('Email input not found in form:', form);
    return;
  }
  const opts: ClearoutOptions = {
    app_token: APP_TOKEN,
    debug: false,
  };

  try {
    await loadClearoutScript();
    await pollForClearoutApi();
    window.clearout.emailValidator.attach($(emailInput), opts);
  } catch (e) {
    console.error('Clearout script or API failed to load:', e);
  }
}

window.addEventListener('message', function (event) {
  if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
    const hsForms = document.querySelectorAll('[data-form-id]');

    // console.log('Clearout script loaded.');

    hsForms.forEach(function (formElement: Element) {
      if (!(formElement instanceof HTMLElement)) {
        // console.warn('Item in hsForms is not an HTMLElement:', formElement);
        return;
      }
      // Prevent double initialization
      // const instanceId = formElement.getAttribute('data-instance-id');
      if (formElement.getAttribute('data-clearout-initialized') === 'true') {
        // console.log('Skipping already initialized form:', instanceId);
        return;
      }

      // Prevent initialization if parent wrapper has data-clearout-disabled attribute set to true
      const formDisabledElement = formElement.closest('[data-clearout-disabled="true"]');
      if (formDisabledElement) {
        console.log('clarout disabled');
        return;
      }

      formElement.setAttribute('data-clearout-initialized', 'true');

      // console.log('Processing form for Clearout and observer:', instanceId);
      attachClearoutEmailValidator(formElement as HTMLFormElement);

      const formObserver = new MutationObserver(() => {
        handleValidation(formElement as HTMLFormElement);
      });

      formObserver.observe(formElement, {
        childList: true,
        subtree: true,
      });
      // console.log('MutationObserver attached to form:', instanceId)
    });
  }
});
